module.exports = __webpack_public_path__ + "static/media/aiva_layout_image.f3b347ad.png";